import { render, staticRenderFns } from "./PurchaseEditLedger.vue?vue&type=template&id=79ca7d7e&scoped=true"
import script from "./PurchaseEditLedger.vue?vue&type=script&lang=ts"
export * from "./PurchaseEditLedger.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseEditLedger.vue?vue&type=style&index=0&id=79ca7d7e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca7d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ca7d7e')) {
      api.createRecord('79ca7d7e', component.options)
    } else {
      api.reload('79ca7d7e', component.options)
    }
    module.hot.accept("./PurchaseEditLedger.vue?vue&type=template&id=79ca7d7e&scoped=true", function () {
      api.rerender('79ca7d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseEditLedger.vue"
export default component.exports